const UTM_PARAM_KEYS = {
  utmSource: 'utm_source',
  utmMedium: 'utm_medium',
  utmCampaign: 'utm_campaign',
  utmContent: 'utm_content',
} as const;

const CONTEXT_25_BASE_URL = 'https://www.text.com/context25';

export const createContext25UtmUrl = (utmParams: {
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  utmContent: string;
}): string => {
  const params = new URLSearchParams();
  params.set(UTM_PARAM_KEYS.utmSource, utmParams.utmSource);
  params.set(UTM_PARAM_KEYS.utmMedium, utmParams.utmMedium);
  params.set(UTM_PARAM_KEYS.utmCampaign, utmParams.utmCampaign);
  params.set(UTM_PARAM_KEYS.utmContent, utmParams.utmContent);

  return `${CONTEXT_25_BASE_URL}?${params.toString()}`;
};
